import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CSSProperties, ReactNode } from "react";

import { useQuickPostV3ModalStore } from "./store";

const panelTransitionClass =
  "col-start-1 row-start-1 flex h-full min-h-0 min-w-0 flex-col will-change-transform motion-reduce:transition-none";
const transitionMs = 220;
const transitionEasing = "cubic-bezier(0.32, 0.72, 0, 1)";

const panelTransitionStyle = (isActive: boolean): CSSProperties => ({
  transition: [
    `opacity ${transitionMs}ms ${transitionEasing}`,
    `transform ${transitionMs}ms ${transitionEasing}`,
    !isActive && `visibility 0ms linear ${transitionMs}ms`,
  ]
    .filter(Boolean)
    .join(", "),
  visibility: isActive ? "visible" : "hidden",
});

interface QuickPostV3ViewTransitionProps {
  composer: ReactNode;
  settings: ReactNode;
}

export const QuickPostV3ViewTransition = ({
  composer,
  settings,
}: QuickPostV3ViewTransitionProps) => {
  const view = useQuickPostV3ModalStore(state => state.view);
  const isSettings = view === "settings";

  return (
    <div
      className="relative grid h-full min-h-0 min-w-0 flex-1 overflow-hidden"
      data-testid="quick-post-v3-view-transition"
    >
      <div
        className={classNames(
          panelTransitionClass,
          isSettings
            ? "pointer-events-none -translate-x-full opacity-0"
            : "translate-x-0 opacity-100",
        )}
        style={panelTransitionStyle(!isSettings)}
      >
        {composer}
      </div>
      <div
        className={classNames(
          panelTransitionClass,
          isSettings
            ? "translate-x-0 opacity-100"
            : "pointer-events-none translate-x-full opacity-0",
        )}
        style={panelTransitionStyle(isSettings)}
      >
        {settings}
      </div>
    </div>
  );
};
